import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';
import {
  EVENT_CATEGORY_LABELS,
  EVENT_CATEGORY_STYLES,
} from '../utils/user-journey.utils';
import type { ActivityEventCategory } from '../types/user-journey.types';

const LEGEND_CATEGORIES: ActivityEventCategory[] = [
  'generation',
  'edit',
  'download',
  'failure',
  'setup',
];

export function EventLegend({ className }: { className?: string }) {
  return (
    <div className={cn('flex flex-wrap items-center gap-4', className)}>
      <span className={portalDs.caption}>Event types</span>
      {LEGEND_CATEGORIES.map((category) => (
        <span key={category} className="inline-flex items-center gap-2 text-[12px] text-[#5E6278]">
          <span
            aria-hidden
            className={cn('h-2.5 w-2.5 rounded-full', EVENT_CATEGORY_STYLES[category].legend)}
          />
          {EVENT_CATEGORY_LABELS[category]}
        </span>
      ))}
    </div>
  );
}
